<template>
  <main-layout :selectedMenu="'2'">
      <div class="channelBox">
        <div class="titleBox clearfix">
          <p class="titleName">{{$t('global.频道')}}</p>
          <div class="updateChan" @click="updateChannel">+ {{$t('global.创建频道')}}</div>
        </div>
        <div class="typeOrder">
          <span :class="{active:orderByType==0}" @click="changeOrder(0)">{{$t('global.默认排序')}}</span>
          <span :class="{active:orderByType==3}" @click="changeOrder(3)">{{$t('works.最多视频')}}</span>
          <span :class="{active:orderByType==2}" @click="changeOrder(2)">{{$t('works.最多成员')}}</span>
        </div>
        <div class="videoListBox clearfix">
          <router-link :to="`/subjectdetail/${item.id}/home?type=3`" target="_blank" class="videoBox" v-for="(item,i) in videoList" :key="i">
            <div class="topBox">
              <img :src="item.banner | imageUrl('',1080,308)" alt="">
            </div>
            <div class="botBox">
              <p class="title">{{language==='zh'?item.title:item.enTitle||item.title}}</p>
              <p class="subTitle">{{language==='zh'?item.introduction:item.enIntroduction||item.introduction}}</p>
              <p class="number">
                <span>
                {{$t('global.视频')}}
                <i>{{item.videoCount || 0}}</i>
              </span>
              <span>
                {{$t('global.成员')}}
                <i>{{item.memberCount || 0}}</i>
              </span>
              </p>
            </div>
          </router-link>
        </div>
      </div>
      <pagination
        :pageSize="pagerParam.pageSize"
        :pageIndex="pagerParam.currentPage"
        :totalRecord="pagerParam.total"
        @OnCurrentChanged="OnCurrentPageChanged"
      />
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import Pagination from "@/components/v2/Pagination";

export default {
  name: "ExploreSubject",
  metaInfo() {
    return {
      title: this.$t("global.发现频道") + " | MANA",
    };
  },
  components: {
    MainLayout,
    Pagination,
  },
  data() {
    return {
      orderByType: 0,
      videoList: [],
      isLogin: localStorage.getItem("auth_token") !== null,
      pagerParam: {
        pageSize: 12,
        currentPage: 1,
        total: 1,
      },
    };
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  created() {
    this.GetVideoList();
    this.buriedPoint(44,0)
  },
  methods: {
    updateChannel() {
      if (this.isLogin) {
        this.$router.push("/subject/create/step1")
      } else {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
      }
    },
    changeOrder(val) {
      this.pagerParam.currentPage = 1;
      this.orderByType = val;
    },
    GetVideoList() {
      var $this = this;
      let pageSize = $this.pagerParam.pageSize;
      this.$http
        .get(
          "/api/topic/findList?orderByType=" +
            this.orderByType +
            "&pageIndex=" +
            this.pagerParam.currentPage +
            "&pageSize=" +
            pageSize
        )
        .then(function (response) {
          if (response.data) {
            $this.videoList = response.data.list;
            $this.pagerParam.total = response.data.totalRecord;
          }
        });
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.GetVideoList();
    },
  },
  watch: {
    orderByType: function () {
      this.GetVideoList();
    },
  },
};
</script>

<style lang="stylus" scoped>
.channelBox {
  width: 1110px;
  margin: 0 auto;
  padding-top: 68px;

  .titleBox {
    height: 66px;

    .titleName {
      float: left;
      height: 66px;
      font-size: 44px;
      font-weight: 600;
      color: #000000;
      line-height: 66px;
    }

    .updateChan {
      float: right;
      padding: 0 36px;
      height: 40px;
      background: #1C21B0;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      margin-top: 13px;
      cursor: pointer;
    }
  }

  .typeOrder {
    margin: 32px 0 30px 0;

    span {
      margin-right: 30px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      cursor: pointer;

      &:hover {
        color: #2026CC;
      }
    }

    .active {
      font-weight: 600;
      color: #0A0A0A;
    }
  }

  .videoListBox {
    .videoBox {
      float: left;
      width: 538px;
      height: 300px;
      border: 1px solid #EBEBEB;
      margin-right: 30px;
      margin-bottom: 40px;
      &:hover {
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
      }
      &:nth-child(2n) {
        margin-right: 0;
      }

      .topBox {
        width: 538px;
        height: 154px;
        position: relative;

        img {
          position: absolute;
          width: 538px;
          height: 154px;
          top: 0;
          left: 0;
        }
      }

      .botBox {

        padding: 16px 15px 0;

        .title {
          height: 30px;
          font-size: 20px;
          font-weight: 600;
          color: #0A0A0A;
          line-height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .subTitle {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-word;
          height: 40px;
          font-size: 13px;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
          margin: 8px 0 16px 0;
        }
        .number {
          height: 18px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 18px;
          span{
            margin-right: 20px;
            i{
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/explore/ExploreSubject.vue